import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = { class: "border p-4" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { class: "border p-4" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { class: "border p-4" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "border p-4" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "border p-4" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = { class: "border p-4" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = { class: "control border p-4" }
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = { class: "border p-4" }
const _hoisted_24 = { class: "h4 mb-3" }
const _hoisted_25 = { class: "control mb-3" }
const _hoisted_26 = { class: "form-check form-check-inline" }
const _hoisted_27 = ["name", "checked"]
const _hoisted_28 = { class: "form-check form-check-inline" }
const _hoisted_29 = ["name", "checked"]
const _hoisted_30 = { key: 0 }
const _hoisted_31 = ["name", "checked"]
const _hoisted_32 = { class: "form-check-label" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h2", null, "Maßnahme \"" + _toDisplayString(_ctx.applicationAction.title) + "\"", 1),
    _createElementVNode("h3", null, _toDisplayString(_ctx.$t('actions.description_of_action')), 1),
    _createElementVNode("b", null, _toDisplayString(_ctx.$t('actions.short_description')), 1),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", {
        innerHTML: _ctx.replace_linebreaks(_ctx.applicationAction.short_description)
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("b", null, _toDisplayString(_ctx.$t('actions.goals_and_milestones')), 1),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("p", {
        innerHTML: _ctx.replace_linebreaks(_ctx.applicationAction.goals_and_milestones)
      }, null, 8, _hoisted_6)
    ]),
    _createElementVNode("b", null, _toDisplayString(_ctx.$t('actions.anchor_points_and_responsible_persons')), 1),
    _hoisted_7,
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("p", {
        innerHTML: _ctx.replace_linebreaks(_ctx.applicationAction.anchor_points_and_responsible_persons)
      }, null, 8, _hoisted_9)
    ]),
    _createElementVNode("b", null, _toDisplayString(_ctx.$t('actions.involved_persons')), 1),
    _hoisted_10,
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("p", {
        innerHTML: _ctx.replace_linebreaks(_ctx.applicationAction.involved_persons)
      }, null, 8, _hoisted_12)
    ]),
    _createElementVNode("b", null, _toDisplayString(_ctx.$t('actions.timings_and_procedure')), 1),
    _hoisted_13,
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("p", {
        innerHTML: _ctx.replace_linebreaks(_ctx.applicationAction.timings_and_procedure)
      }, null, 8, _hoisted_15)
    ]),
    _createElementVNode("b", null, _toDisplayString(_ctx.$t('actions.costs_and_financing')), 1),
    _hoisted_16,
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("p", {
        innerHTML: _ctx.replace_linebreaks(_ctx.applicationAction.costs_and_financing)
      }, null, 8, _hoisted_18)
    ]),
    _createElementVNode("b", null, _toDisplayString(_ctx.$t('actions.evaluation_and_monitoring')), 1),
    _hoisted_19,
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("p", {
        innerHTML: _ctx.replace_linebreaks(_ctx.applicationAction.evaluation_and_monitoring)
      }, null, 8, _hoisted_21)
    ]),
    _createElementVNode("b", null, _toDisplayString(_ctx.$t('actions.link_to_describe')), 1),
    _hoisted_22,
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("p", null, _toDisplayString(_ctx.applicationAction.link_to_describe), 1)
    ]),
    _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$t('actions.legal_requirement')), 1),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("input", {
          name: 'legal-yes-' + _ctx.applicationAction.id ,
          type: "radio",
          class: "form-check-input",
          checked: _ctx.applicationAction.legal_requirement,
          disabled: ""
        }, null, 8, _hoisted_27),
        _createTextVNode(_toDisplayString(_ctx.$t('text.yes')), 1)
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("input", {
          name: 'legal-no-' + _ctx.applicationAction.id ,
          type: "radio",
          class: "form-check-input",
          checked: !_ctx.applicationAction.legal_requirement,
          disabled: ""
        }, null, 8, _hoisted_29),
        _createTextVNode(_toDisplayString(_ctx.$t('text.no')), 1)
      ])
    ]),
    _createElementVNode("h3", null, _toDisplayString(_ctx.$t('actions.link_to_field_of_action')), 1),
    (!_ctx.isPrint)
      ? (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(_ctx.$t('actions.fields_of_action_subtitle')), 1))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fieldsOfAction, (field, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: field.id,
        class: _normalizeClass([index === _ctx.fieldsOfAction.length -1 ? 'form-check print' : 'form-check'])
      }, [
        _createElementVNode("input", {
          name: 'field_of_action-' + field.id ,
          type: "checkbox",
          class: "form-check-input",
          checked: _ctx.applicationAction.field_of_action.indexOf(field.id) !== -1,
          disabled: ""
        }, null, 8, _hoisted_31),
        _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.$t('fields_of_action.field_no', { number: index + 1 })), 1),
        _hoisted_33,
        _createElementVNode("p", null, _toDisplayString(_ctx.$t(_ctx.getFieldTitle(field.field_of_action_type))), 1)
      ], 2))
    }), 128))
  ], 64))
}